import { ORIGINALS_MENU_ITEM_BY_BRAND } from "../constants";

const resolveMenuItem = (
  category: string | undefined,
  brand: string,
): string | undefined => {
  if (!category || category === "all") return undefined;
  if (category === "originals") return ORIGINALS_MENU_ITEM_BY_BRAND[brand];
  return category;
};

export default resolveMenuItem;
